import { render, staticRenderFns } from "./data-filters.vue?vue&type=template&id=3212d708&scoped=true"
import script from "./data-filters.vue?vue&type=script&lang=js"
export * from "./data-filters.vue?vue&type=script&lang=js"
import style0 from "./data-filters.vue?vue&type=style&index=0&id=3212d708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3212d708",
  null
  
)

export default component.exports